import React from 'react';
import { Container, Typography, Box, Paper, CircularProgress, Alert } from '@mui/material';

const TermsOfService: React.FC = () => {
    const [pdfLoading, setPdfLoading] = React.useState(true);
    const [pdfError, setPdfError] = React.useState(false);

    // S3 URL for the PDF
    const pdfUrl = 'https://podscope.s3.us-east-1.amazonaws.com/legal/TyC.pdf';

    const handlePdfLoad = () => {
        setPdfLoading(false);
        setPdfError(false);
    };

    const handlePdfError = () => {
        setPdfLoading(false);
        setPdfError(true);
    };

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper elevation={1} sx={{ p: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom>
                    Términos de Servicio
                </Typography>

                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Última actualización: 1 de Octubre de 2025
                </Typography>

                <Box sx={{ mt: 4, position: 'relative' }}>
                    {pdfLoading && (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: 400,
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            zIndex: 1
                        }}>
                            <CircularProgress />
                        </Box>
                    )}

                    {pdfError ? (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            No se pudo cargar el documento PDF. Por favor, intenta nuevamente más tarde.
                        </Alert>
                    ) : (
                        <Box
                            component="iframe"
                            src={pdfUrl}
                            sx={{
                                width: '100%',
                                height: '80vh',
                                minHeight: 600,
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1,
                            }}
                            onLoad={handlePdfLoad}
                            onError={handlePdfError}
                            title="Términos de Servicio"
                        />
                    )}
                </Box>

                <Box sx={{ mt: 3, textAlign: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                        Si tienes problemas para ver el documento, puedes{' '}
                        <a
                            href={pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: '#1976d2',
                                textDecoration: 'none'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                            onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                        >
                            descargarlo aquí
                        </a>
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default TermsOfService;
